export const iconFontAwesomeUsersPeopleUserTag = (
	<i className="fa-solid fa-user-tag"></i>
);
